// extracted by mini-css-extract-plugin
export default {"chips-container":"chips-container_ReZT_4Kf"};